"use client";

import { Apple, FileText, Instagram, Music, Play, Smartphone, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Connect() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const platforms = [{
    name: "Quote Request",
    caption: "Get Estimate",
    icon: FileText,
    to: "/ContactPage",
    primary: true
  }, {
    name: "Instagram",
    caption: "@metalline",
    icon: Instagram,
    to: "#",
    primary: false
  }, {
    name: "LinkedIn",
    caption: "Company News",
    icon: Smartphone,
    to: "#",
    primary: false
  }];
  return <section data-section-id="7669" id="connect-with-us" className="dark bg-background py-24 md:py-32">
      <div className="mx-auto max-w-[1240px] px-6 md:px-20">
        <div ref={ref} className={`mx-auto max-w-[680px] text-center transition-all duration-[720ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <h2 className="font-default text-foreground" style={{
          fontSize: "clamp(2.1rem, 4vw, 3.5rem)",
          fontWeight: 600,
          letterSpacing: "-0.02em",
          lineHeight: 1.08
        }}>
            Connect with{" "}
            <span style={{
            fontStyle: "italic",
            fontWeight: 300
          }}>
              MetalLine
            </span>
            .
          </h2>
          <p className="mt-6 font-default text-muted-foreground" style={{
          fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
          fontWeight: 400,
          lineHeight: 1.6
        }}>
            Follow our latest architectural projects, material innovations, and 
            expert insights into premium exterior renovations across Calgary.
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-5 ![margin:64px_0px_0px_0px] !p-0 !opacity-[1]">
          {platforms.map((platform, i) => {
          const Icon = platform.icon;
          const delay = i * 90;
          return <Link key={platform.name} to={platform.to} data-index={i} aria-label={`${platform.name} — ${platform.caption}`} className={`group relative flex min-h-[140px] w-full sm:w-[calc(50%-10px)] md:w-[280px] flex-col items-center justify-center gap-3 rounded-lg border border-border bg-card p-5 md:p-6 shadow-md transition-all duration-[280ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1 hover:shadow-lg ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} style={{
            transitionDelay: isVisible ? `${delay}ms` : "0ms"
          }}>
                {platform.primary}
                <Icon className="size-10 text-foreground transition-colors duration-[220ms] group-hover:text-primary" strokeWidth={1.75} />
                <div className="text-center">
                  <h4 className="font-default text-foreground" style={{
                fontSize: "clamp(1.05rem, 1.2vw, 1.15rem)",
                fontWeight: 600,
                lineHeight: 1.3
              }}>
                    {platform.name}
                  </h4>
                  <p className="mt-1 font-default text-muted-foreground" style={{
                fontSize: "0.875rem",
                fontWeight: 500,
                lineHeight: 1.45
              }}>
                    {platform.caption}
                  </p>
                </div>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}